import { gql } from '@apollo/client';
import { CONTENT_ITEM_FIELDS } from './contentItem';
export const CONTENT_FIELDS = gql `
  ${CONTENT_ITEM_FIELDS}
  fragment ContentFields on Content {
    id
    createdAt
    updatedAt
    clientId
    name
    code
    contentType
    criteria
    extraData
    isActive
    startsOn
    expiresOn
    contentItems {
      ...ContentItemFields
    }
  }
`;
export const CONTENTS = gql `
  ${CONTENT_FIELDS}
  query CONTENTS($spec: ContentSpec!) {
    contents(spec: $spec) {
      ...ContentFields
    }
  }
`;
export const SAVE_CONTENT = gql `
  ${CONTENT_FIELDS}
  mutation SAVE_CONTENT($input: ContentInput!) {
    saveContent(input: $input) {
      ...ContentFields
    }
  }
`;
export const DELETE_CONTENT = gql `
  ${CONTENT_FIELDS}
  mutation DELETE_CONTENT($id: Int!) {
    deleteContent(id: $id) {
      ...ContentFields
    }
  }
`;
export const RESOURCES = gql `
  query RESOURCES($spec: ResourceSpec!) {
    resources(spec: $spec) {
      id
      title
      s3Key
      publicUrl
    }
  }
`;
